import StyledWrapper from "./style";
import { FranchiseLogo } from "../../../components/others/FranchiseBranding";

export default function TurnCancellation() {
  return (
    <div className="h-screen bg-[#525151]">
      <StyledWrapper.Header>
        <div className="w-full bg-[#343030] py-6 px-12">
          <FranchiseLogo className="h-10" />
          <p className="text-white text-xs">Portal de Clientes</p>
        </div>
      </StyledWrapper.Header>

      <StyledWrapper.Card>
        <StyledWrapper.CardTitle>Cancelaste tu turno</StyledWrapper.CardTitle>
        <StyledWrapper.CardContent>
          <p>
            Proximamente nos contactaremos para ofrecerte una nueva fecha de
            turno.
          </p>
          <p className="mt-7 ">Puedes cerrar esta ventana</p>
        </StyledWrapper.CardContent>
      </StyledWrapper.Card>
    </div>
  );
}
